module.exports = __webpack_public_path__ + "img/in_car.722202c6.png";